//com.southvanmed/src/config.js
const config = {
  service: 'https://api.southvanmed.com',
  book_appointment: 'https://appointment.southvanmed.com',
  order_labtest: 'https://asklabtest.com',
  //old captcha key
  // captcha_key:'6LfIA8UZAAAAACK5A7BA8Qbz-4jNe5mfVWKk5H00',
  //updated gcp captcha key
  captcha_key: '6LcXWiwrAAAAAGGtQ5v5-nmPH7ti0W_hiyZ6WfQv',
  askmedication: 'https://askmedication.com',
  hasFamilyDoc: '1998',
  noFamilyDoc: '1999',
  askmedApiHost: 'https://api.askmedication.com',
  askmedSecret: 'cXpMnLhQ*7#qX1i',
  stripePublicKey: 'pk_live_Fkqzpa0SU25HsqoCBbhBSYLD00rBmKxzRA',
  immigration_url: 'https://immigration.southvanmed.com',
  homepageUrl: 'SouthVanMed.com',
  clinicName: 'South Vancouver Medical Clinic',
  service_email: 'info@southvanmed.com',
  socialMedia: {
    // X (formerly Twitter) - Active
    x: {
      url: 'https://x.com/SouthVanMed',
      icon: 'fab fa-x-twitter', // Using Font Awesome X icon (FA 6.5.0)
      label: 'Follow us on X'
    },
    // YouTube - Future improvement (currently placeholder)
    youtube: {
      url: '#',
      icon: 'fab fa-youtube',
      label: 'Subscribe to our YouTube channel'
    }
    // Commented out other social media platforms
    // facebook: {
    //     url: 'https://facebook.com/southvanmed',
    //     icon: 'fab fa-facebook-f',
    //     label: 'Like us on Facebook'
    // },
    // instagram: {
    //     url: 'https://instagram.com/southvanmed',
    //     icon: 'fab fa-instagram',
    //     label: 'Follow us on Instagram'
    // },
    // linkedin: {
    //     url: 'https://linkedin.com/company/southvanmed',
    //     icon: 'fab fa-linkedin',
    //     label: 'Connect with us on LinkedIn'
    // },
    // pinterest: {
    //     url: 'https://pinterest.com/southvanmed',
    //     icon: 'fab fa-pinterest',
    //     label: 'Follow us on Pinterest'
    // }
  }
};
export default config;
